<div class="grid">
    <div class="col-12">
        <div class="card">
            <!-- -->
            <!-- FAKE DATAVIEW (só header + skeletons) -->
            <p-dataView *ngIf="loadingProducts" [value]="[0,1,2,3]" [paginator]="false" layout="grid">
                <!-- header idêntico ao real -->
                <ng-template pTemplate="header">
                    <div class="flex justify-end">
                    </div>
                </ng-template>
                <!-- skeleton grid (mesmo layout do seu gridItem) -->
                <ng-template pTemplate="gridItem">
                    <div class="col-12 lg:col-3 md:col-4">
                        <div
                            class="card p-0 m-3 border-1 surface-border h-60 overflow-hidden flex flex-column justify-between ss-l-height">
                            <div class="flex justify-content-between align-items-start p-3 flex-shrink-0">
                                <p-skeleton width="50%" height="1.5rem"></p-skeleton>
                                <p-skeleton shape="circle" size="1.5rem"></p-skeleton>
                            </div>
                            <div class="flex flex-column align-items-center text-center p-3 flex-1">
                                <p-skeleton width="50px" height="50px" class="mb-3"></p-skeleton>
                                <p-skeleton width="80%" height="1.25rem"></p-skeleton>
                                <p-skeleton width="60%" height="1rem"></p-skeleton>
                            </div>
                        </div>
                    </div>
                </ng-template>
            </p-dataView>
            <!-- -->
            <p-dataView *ngIf="!loadingProducts" #dv [value]="products" [paginator]="false" [rows]="9" filterBy="key"
                layout="grid">
                <ng-template pTemplate="header">
                    <div class="flex justify-end">
                    </div>
                </ng-template>
                <ng-template pTemplate="listItem" let-product>
                    <div class="col-12 cursor-pointer" (click)="onProductClick(product)"
                        [ngClass]="{ 'disabled-card': isEcommerceLocked(product) }">
                        <div class="flex flex-column md:flex-row align-items-center p-3 w-full h-60">
                            <img [src]="product.logo" [alt]="product.key" class="my-4 md:my-0 w-4rem mr-5" />
                            <div class="flex-1 flex flex-column align-items-left text-left md:text-left">
                                <div class="flex justify-content-between align-items-center w-full">
                                    <div class="font-bold text-2xl">{{ product.key == 'google' ? 'Youtube' : product.key
                                        | titlecase }}</div>
                                    <p-tag *ngIf="product.isPinned" severity="info" [rounded]="true"
                                        value="Instalado"></p-tag>
                                </div>
                                <div class="mb-2">{{ product.description }}</div>
                                <div class="flex align-items-center mt-2">
                                    <i class="pi pi-tag mr-2"></i>
                                    <span class="font-semibold">{{ product.category }}</span>
                                </div>
                            </div>
                        </div>
                    </div>
                </ng-template>


                <ng-template pTemplate="gridItem" let-product>
                    <div class="col-12 lg:col-3 md:col-4 cursor-pointer" (click)="onProductClick(product)"
                        [ngClass]="{ 'disabled-card': isEcommerceLocked(product) }">
                        <!-- cartão agora com overflow-hidden + altura fixa -->
                        <div
                            class="card p-0 m-3 border-1 surface-border flex flex-column justify-between h-60 overflow-hidden ss-l-height">

                            <!-- cabeçalho – não mexe -->
                            <div class="flex justify-content-between align-items-start p-3 flex-shrink-0 relative">
                                <div class="flex align-items-center">
                                    <i class="pi pi-tag mr-2"></i>
                                    <span class="font-semibold">{{ product.category }}</span>
                                </div>
                                <i class="pi pi-info-circle text-sm cursor-pointer" (click)="$event.stopPropagation()"
                                    [pTooltip]="product.description" tooltipPosition="right" tooltipEvent="focus" tabindex="0"
                                    style="position: absolute; top: 0.75rem; right: 0.75rem;"></i>
                            </div>

                            <!-- conteúdo – ocupando o espaço restante, mas sem empurrar o container -->
                            <div class="flex flex-column align-items-center text-center p-3 flex-1">
                                <div class="relative mb-4 w-2 h-2 md:w-2 md:h-2 lg:w-2 lg:h-2  flex justify-content-center align-items-center overflow-hidden"
                                    style="height: 50px;width: 50px !important;">
                                    <img [src]="product.logo" [alt]="product.key"
                                        class="max-w-full max-h-full object-contain" />
                                </div>
                                <div class="text-2xl font-bold flex align-items-center justify-content-center gap-2 leading-tight w-full min-w-0">
                                    <span class="ss-l-app-title-text">{{ product.key == 'google' ? 'Youtube' : product.key === 'instagram' ? 'Instagram Business' : (product.key | titlecase) }}</span>
                                    <i *ngIf="product.isPinned" class="pi pi-check-circle text-green-400 text-base flex-shrink-0"></i>
                                </div>
                            </div>

                        </div>
                    </div>
                </ng-template>


            </p-dataView>

        </div>
    </div>
</div>


<app-shopify-app *ngIf="showSidebar" [(visible)]="showSidebar" [selectedStoreApp]="selectedStoreApp"
    [selectedProduct]="selectedProduct" [connected]="connected" [loadingBtn]="loadingBtn" [loading]="sidebarLoading"
    (connect)="connectApp()" (disconnect)="confirmRemove()" (close)="closeSidebar()">
</app-shopify-app>

<app-nuvemshop *ngIf="showSidebarNuvemShop" [(visible)]="showSidebarNuvemShop" [selectedStoreApp]="selectedStoreApp"
    [selectedProduct]="selectedProduct" [connected]="connected" [loadingBtn]="loadingBtn" [loading]="sidebarLoading"
    [nuvemshopAccounts]="nuvemshopAccounts" (connect)="connectApp()"
    (disconnect)="confirmRemove()" (close)="closeSidebar()">
</app-nuvemshop>

<app-meta-app [(visible)]="showSidebarInstagram" [instagramAccounts]="instagramAccounts" [loading]="sidebarLoading"
    (addInstagramAccount)="instagramConnection()" (removeInstagramAccountEvent)="removeInstagramAccount($event)"
    (close)="closeSidebarInsta()">
</app-meta-app>


<app-tiktok [(visible)]="showSidebarTiktok" [tiktokAccounts]="tiktokAccounts" [loading]="sidebarLoading"
    (addTiktokAccount)="tiktokConnection()"
    (removeTiktokAccountEvent)="removeTiktokAccount($event)" (close)="closeSidebarTikTok()">
</app-tiktok>

<app-google [(visible)]="showSidebarGoogle" [googleAccounts]="googleAccounts" [loading]="sidebarLoading"
    (addGoogleAccount)="googleConnection()"
    (removeGoogleAccountEvent)="removeGoogleAccount($event)" (close)="closeSidebarGoogle()">
</app-google>


<app-ga4 [(visible)]="showSidebarGa4" [ga4Accounts]="ga4Accounts" [loading]="sidebarLoading"
    (addGa4Account)="ga4Connection()" (saveDimensions)="onSaveDimensions($event)"
    (removeGa4AccountEvent)="removeGa4Account($event)" [isSavingDimensions]="isSavingDimensions" (close)="closeSidebarGa4()" (saveProperties)="onSaveGa4Properties($event)">
</app-ga4>







<app-dialog-aguarde [visible]="displayAguarde"></app-dialog-aguarde>
